function redirectUri() {
    var url = window.location.href;
    var arr = url.split("/");
    var result = arr[0] + "//" + arr[2];
    return result + "/startSession";
}

//TODO: OLD TENANT!
/*export const AUTH_CONFIG_EMAIL = {
    domain: 'tryggaavtal.eu.auth0.com',
    clientID: 'JX2seREg3qc9Auz3RcZhptyHDuLsfqWQ',
    redirectUri: redirectUri(),
    audience: 'https://app.legly.io'
};*/

export const AUTH_CONFIG = {
    domain: 'legly.eu.auth0.com',
    clientID: 'h2js4a6dlG8jg3j1OmxXmjUyKhEw172o',
    redirectUri: redirectUri(),
    audience: 'https://app.legly.io'
};

// export const AUTH_CONFIG = {
//     domain: "legly-external-sso-tenant.eu.auth0.com",
//     clientID: "MdvIluwawnV9ngYhfujcpOJrMiAP4zo4",
//     redirectUri: redirectUri(),
//     audience: ''
// };


// WEBPACK FOOTER //
// ./src/Auth0Config.js